var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 182,
    viewBox: "0 0 322 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.663 86.3961C248.516 78.0857 251.457 72.5354 253.568 64.3445C254.149 62.0929 247.682 61.5424 249.43 59.2202C250.778 57.4275 255.323 58.6018 255.52 58.3293C256.905 56.4178 253.752 52.7235 257.707 52.3353C260.408 52.07 262.051 54.3959 263.797 55.9657C263.797 55.9657 264.193 56.3786 264.318 56.3289C265.575 55.8317 262.28 50.6697 266 50.6866C268.576 50.6984 270.321 52.2555 271.953 54.0673C272.096 54.2255 273.365 56.4155 273.494 56.3449C275.21 55.4043 272.022 50.8648 276.439 50.7345C278.673 50.6688 280.334 53.054 281.559 54.5969C282.195 55.3998 282.031 58.0637 282.815 57.4049C283.798 56.5792 283.311 50.7459 286.79 52.6785C290.547 54.7656 289.669 64.2511 290.485 64.6649C290.964 64.9077 296.161 55.8264 299.828 60.9675C304.228 67.1347 296.144 69.9417 296.427 73.5973C296.537 75.0282 298.296 92.8792 290.181 99.6996C284.497 104.477 265.452 94.8219 257.048 90.5111L252.663 86.3961Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M287.314 94.5574C286.666 98.1108 284.776 96.8003 284.148 94.2827C283.013 89.7308 285.16 83.2783 282.017 79.2664C275.841 71.3843 262.602 67.7985 254.562 75.0549C247.006 81.8734 248.741 110.355 250.3 119.736C250.975 123.798 259.483 126.974 259.483 126.974L259.359 134.664C259.359 134.664 267.543 151.565 270.146 151.783C274.814 152.173 279.712 154.438 282.965 150.088C283.147 149.846 287.615 135.819 287.615 135.819L288.416 106.724C288.416 106.724 294.204 108.342 295.715 100.386C296.813 94.6048 288.325 89.0067 287.314 94.5574Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.823 166.607C259.202 199.356 225.201 162.282 225.201 162.282C228.994 145.015 231.885 140.608 242.604 138.132C245.957 137.358 248.852 136.728 251.247 136.23C256.508 135.132 259.36 134.664 259.36 134.664C271.42 145.444 287.616 135.82 287.616 135.82C287.616 135.82 289.669 136.551 294.51 138C297.148 138.789 297.685 138.215 302.098 139.426C316.395 143.354 318.319 145.975 319.952 154.271C321.585 162.567 320.823 166.607 320.823 166.607Z",
    fill: "#0158E6",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M294.509 138C294.245 138.279 270.993 158.058 251.248 136.232L251.246 136.23C256.507 135.132 259.359 134.664 259.359 134.664C271.418 145.444 287.615 135.82 287.615 135.82C287.615 135.82 289.667 136.551 294.509 138Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3412 63.6761C51.3412 63.6761 64.4367 53.6527 72.434 66.9835C80.4309 80.3146 80.8308 111.387 85.4291 122.813C85.4291 122.813 47.4427 140.153 12.3555 121.911C12.3555 121.911 16.0844 108.841 18.0032 95.0415C21.7521 68.0863 34.4472 50.746 51.3412 63.6761Z",
    fill: "#0158E6",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.516 74.8955C54.516 74.8955 59.5542 78.4348 64.8565 82.1104C70.1588 85.786 70.6323 96.2245 70.6323 96.2245C70.6323 96.2245 74.6726 94.8264 74.5548 101.261C74.4371 107.695 70.3937 108.453 70.3937 108.453C70.3937 108.453 70.9164 116.442 65.794 123.283C60.6717 130.123 57.1796 129.615 57.1796 129.615L57.819 143.227L43.6028 156.85L36.0949 141.529L36.8276 123.336C36.8276 123.336 31.6616 117.306 31.199 109.962C31.199 109.962 23.0262 111.353 23.4117 102.927C23.7975 94.5007 30.3509 94.8871 33.435 98.4433C33.435 98.4433 31.7389 90.7126 40.3738 84.9919C49.0092 79.271 54.516 74.8955 54.516 74.8955Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.886 41.6418C106.886 41.6418 103.198 63.9272 84.4609 61.2286C84.4609 61.2286 109.178 70.8227 118.647 45.4391C118.647 45.4391 190.706 47.9376 204.46 48.7369C218.214 49.5366 228.978 51.1356 230.772 30.2491C232.566 9.36268 227.981 5.26558 201.968 2.6673C175.955 0.0689434 147.948 0.968508 127.716 2.26765C107.484 3.56687 105.192 9.56282 106.886 41.6418Z",
    fill: "#0158E6",
    stroke: "#F9FBFD",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M238.746 109.546C238.746 109.546 218.656 112.018 211.077 96.7271C211.077 96.7271 210.712 95.3537 210.986 86.2891C211.26 77.2246 214.456 68.0684 194.641 67.5194C174.825 66.9698 150.809 65.8711 137.659 66.1459C124.51 66.4207 119.396 70.9986 118.3 85.6484C117.204 100.298 116.839 111.56 140.216 112.476C163.593 113.392 200.86 115.69 207.607 108.63C207.607 108.63 217.835 117.786 238.746 109.546Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M264.005 89.5771C263.734 91.5553 259.645 101.535 261.128 102.85C262.154 103.76 264.056 103.252 265.256 103.417",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M280.27 88.4586C280.27 85.2342 274.392 84.8099 273.137 87.3267",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M258.305 86.5548C258.305 83.6197 253.198 82.8509 251.941 85.3714",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M275.207 107.178L263.785 111.99C263.785 111.99 272.412 119.24 275.207 107.178Z",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.527 94.631C270.527 92.8867 271.289 91.4727 272.228 91.4727C273.168 91.4727 273.93 92.8867 273.93 94.631C273.93 96.3754 273.168 97.789 272.228 97.789C271.289 97.789 270.527 96.3754 270.527 94.631Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.535 93.9826C251.535 92.2383 252.296 90.8242 253.236 90.8242C254.176 90.8242 254.937 92.2383 254.937 93.9826C254.937 95.727 254.176 97.141 253.236 97.141C252.296 97.1409 251.535 95.727 251.535 93.9826Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M302.246 164.434L302.496 174.678",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M241.726 162.865L240.307 172.842",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8786 116.112L46.5996 114.148C46.5996 114.148 52.1377 127.219 57.8786 116.112Z",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.272 98.8926C55.1134 100.508 55.0711 102.108 55.606 103.665C56.055 104.971 57.2803 106.672 56.7458 108.116C56.4336 108.96 55.6751 109.686 55.1465 110.4",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2917 90.2495C64.7229 88.3462 62.6283 88.1734 61.2148 90.4418",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3599 90.2316C46.8661 87.4451 43.5966 88.6093 42.4082 90.9247",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1523 100.553C62.1523 98.8095 62.9136 97.3955 63.8534 97.3955C64.7928 97.3955 65.5545 98.8095 65.5545 100.553C65.5545 102.298 64.7929 103.712 63.8534 103.712C62.9136 103.712 62.1523 102.298 62.1523 100.553Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7773 100.893C44.7773 99.1484 45.539 97.7344 46.4784 97.7344C47.4178 97.7344 48.1795 99.1484 48.1795 100.893C48.1795 102.637 47.4179 104.051 46.4784 104.051C45.539 104.051 44.7773 102.637 44.7773 100.893Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2387 170.898C53.9383 193.984 1 170.276 1 170.276C3.048 160.133 6.58608 152.043 18.3145 147.81C22.8907 146.159 26.6033 144.84 29.4284 143.846C33.8451 142.29 36.0959 141.527 36.0959 141.527C46.8622 152.17 57.8195 143.225 57.8195 143.225C57.8195 143.225 60.118 143.665 65.464 145.26C67.2807 145.802 69.4495 146.476 71.9987 147.314C82.0535 150.612 85.0322 153.349 87.0802 158.763C89.1281 164.177 91.2387 170.898 91.2387 170.898Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4633 145.26C65.4633 145.26 47.7938 163.866 29.4307 143.849C29.4292 143.847 29.4292 143.847 29.4277 143.846C33.8444 142.29 36.0952 141.527 36.0952 141.527C46.8616 152.17 57.8188 143.225 57.8188 143.225C57.8188 143.225 60.1174 143.665 65.4633 145.26Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0645 162.014C70.9057 163.013 71.3752 164.202 72.1541 165.238C74.6741 168.587 78.2422 172.545 78.7344 176.908",
    stroke: "white",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2016 168.618C17.7166 168.474 17.2081 168.745 17.0654 169.23C16.4687 171.26 15.8584 173.295 15.2616 175.325C15.1189 175.809 15.4021 176.306 15.8865 176.45C16.3709 176.593 16.88 176.321 17.0227 175.837C17.6199 173.808 18.2147 171.772 18.812 169.743C18.9551 169.258 18.6865 168.761 18.2016 168.618Z",
    stroke: "white",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3411 129.784C57.3411 129.784 48.3608 131.505 40.918 125.817L57.3411 129.784Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3411 129.784C57.3411 129.784 48.3608 131.505 40.918 125.817",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M259.484 126.975C259.484 126.975 265.654 127.588 270.782 126.945C277.519 125.389 280.564 120.326 280.564 120.326",
    stroke: "black",
    strokeMiterlimit: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartVector);
export default __webpack_public_path__ + "static/media/start_vector.f8a76d8b7868285cc33e3c91c1aa8cc4.svg";
export { ForwardRef as ReactComponent };